const selectors = {
  productMedia: document.querySelector('[data-productMedia]')
};

  const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
  window.productMedia = mediaJSON;
  class TemplateProductJS {
    constructor() {
      
    }
  
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();

/* 
share button function
copies the given page url link into the clipboard
*/
class EventLinkCopy {
  constructor (){
      this.Alllinks = document.querySelectorAll('[data-copyEventsLink]');
      this.init();
  }
  init() {
    if(this.Alllinks.length){
      this.Alllinks.forEach(f=>{ 
        f.addEventListener('click',(e)=>{
          e.preventDefault();
            let link = f.dataset.link;
            if(link !='' && link != undefined && link != '#'){
              navigator.clipboard.writeText(link); 
              if(window.innerWidth < 991){
                f.querySelector('[data-text-status]').innerText='Copied';
                setTimeout(()=>{f.querySelector('[data-text-status]').innerText='Share'},4000);
              } else {
                f.querySelector('[data-text-status]').innerText='Item Link Copied';
                setTimeout(()=>{f.querySelector('[data-text-status]').innerText='Share This Item'},4000);
              }
             
            }
        });
      });
    }
  }

}
typeof EventLinkCopy !== 'undefined' &&  new EventLinkCopy();
